import { render, staticRenderFns } from "./AddBlocksToDraft.vue?vue&type=template&id=439f3c76&scoped=true"
import script from "./AddBlocksToDraft.vue?vue&type=script&lang=js"
export * from "./AddBlocksToDraft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "439f3c76",
  null
  
)

export default component.exports